module.exports = __webpack_public_path__ + "img/btn-marquee.0a4f3459.svg";